import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Iconify from '../Iconify';
import { SessionMode } from '../../enums/shared.enums';
import useLocales from '../../hooks/useLocales';

export const SESSION_MODE_ICON_MAP: Record<SessionMode, string> = {
    [SessionMode.PHONE]: 'material-symbols:call-outline',
    [SessionMode.VIDEO]: 'material-symbols:videocam-outline',
};

export function sessionModeLabelKey(mode: SessionMode) {
    return `constants.common.sessionMode.${
        mode === SessionMode.PHONE ? 'phone' : 'video'
    }`;
}

interface Props {
    mode?: SessionMode | null;
}

export default function SessionModeIndicator({ mode }: Props) {
    const { translate } = useLocales();

    if (!mode) {
        return null;
    }

    const label = translate(sessionModeLabelKey(mode));

    return (
        <Tooltip title={label}>
            <Box
                aria-label={label}
                sx={{
                    width: 32,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                    bgcolor: 'background.neutral',
                    color: 'text.secondary',
                    flexShrink: 0,
                }}
            >
                <Iconify icon={SESSION_MODE_ICON_MAP[mode]} width={18} height={18} />
            </Box>
        </Tooltip>
    );
}
